//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

// @ADD Component types
interface IError404ScreenLayoutProps {}

const Error404ScreenLayout: React.FC<IError404ScreenLayoutProps> = (props) => {
  const { t } = useTranslation()

  return(
    <div className='container mt-3'>
      {t('errors.404.content')}
    </div>
  )
}

export default Error404ScreenLayout
